@if (cardModalService.isVIP()) {
    <tag-pds3 type="dark" color="info" class="tags_vip_active"> VIP </tag-pds3>
}
